import React from 'react'
import { motion } from 'framer-motion';

const Loader = () => {
    return (
        <motion.div
            className='h-screen'
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: .5 }}
        >
            <div className='flex justify-center items-center h-screen w-full bg-slate-100 dark:bg-slate-900 text-4xl z-90'>
                <div className="loader">
                    <span>DevSG</span>
                    <span>DevSG</span>
                </div>
            </div>
        </motion.div>

    )
}

export default Loader